var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34546 2.28832L8.19423 7.16927C8.89176 7.72483 9.08866 7.91106 9.44423 8.0026C9.79979 8.09415 10.1022 8.08352 10.4164 8.0026C10.7723 7.91098 11.1553 7.64375 11.8053 7.16927L17.6541 2.28832M1.38867 11.6218V4.38374C1.38867 3.31698 1.38867 2.78319 1.59724 2.37574C1.7807 2.01734 2.07323 1.72616 2.43329 1.54354C2.84263 1.33594 3.37888 1.33594 4.45059 1.33594H15.5494C16.6211 1.33594 17.1562 1.33594 17.5655 1.54354C17.9256 1.72616 18.2191 2.01734 18.4025 2.37574C18.6109 2.7828 18.6109 3.31593 18.6109 4.38061V11.6251C18.6109 12.6897 18.6109 13.2221 18.4025 13.6292C18.2191 13.9876 17.9256 14.2793 17.5655 14.4619C17.1566 14.6693 16.6217 14.6693 15.5521 14.6693H4.44744C3.37783 14.6693 2.84223 14.6693 2.43329 14.4619C2.07323 14.2793 1.7807 13.9876 1.59724 13.6292C1.38867 13.2217 1.38867 12.6886 1.38867 11.6218Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.069b6f1ce46fb13546a34aa58264c1fb.svg";
export { ForwardRef as ReactComponent };